import { AppEnvironments } from '@models/app-environments';

export const environment = {
  environment: AppEnvironments.integration,
  apiUrl: 'https://integration-zbportal-linux.azurewebsites.net',
  proxyApiUrl: '',
  assetUrl: 'https://integration-cdn.zaner-bloser.com/',
  skofUrl: 'https://integration-cdn.zaner-bloser.com',
};
